import React, { memo } from 'react'

export default memo(() => (
  <svg width="1em" height="1em" viewBox="0 0 183 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="90.7692" cy="108.718" rx="90.7692" ry="91.2821" fill="#F2F2F2" />
    <path
      d="M149.769 59.9736L162.678 51.715C158.49 46.4795 153.74 41.7118 148.515 37.5054L136.008 47.114C141.106 50.822 145.733 55.1401 149.769 59.9736Z"
      fill="#C4C4C4"
    />
    <path
      d="M161.555 79.4094L176.145 74.8695C173.889 69.2241 171.087 63.8571 167.804 58.8311L154.969 67.0407C157.522 70.9321 159.74 75.0652 161.554 79.4094H161.555Z"
      fill="#C4C4C4"
    />
    <path
      d="M91.3348 184.757C49.3765 184.757 15.2469 150.625 15.2469 108.665C15.2469 66.7067 49.3784 32.5772 91.3348 32.5772C104.677 32.5772 117.219 36.039 128.135 42.0927L141.098 32.1368C126.771 22.7881 109.682 17.3311 91.3344 17.3311C40.9719 17.3311 0 58.3029 0 108.665C0 159.028 40.9719 200 91.3344 200C126.598 200 157.237 179.899 172.448 150.569H154.803C141.17 171.148 117.818 184.757 91.3352 184.757L91.3348 184.757Z"
      fill="#C4C4C4"
    />
    <path
      d="M167.415 108.665H182.658C182.658 107.277 182.615 105.897 182.552 104.526H167.297C167.373 105.897 167.415 107.275 167.415 108.665H167.415Z"
      fill="#C4C4C4"
    />
    <path
      d="M166.321 95.7561H181.752C181.14 91.4518 180.225 87.2501 179.032 83.1611L164.477 87.6916C165.23 90.3247 165.851 93.0144 166.321 95.7561H166.321Z"
      fill="#C4C4C4"
    />
    <path
      d="M125.332 161.312H60.6905C53.8033 161.296 48.2199 155.712 48.2031 148.825V12.4873C48.2199 5.60022 53.8033 0.0167671 60.6905 0H125.332C132.219 0.0167671 137.803 5.60022 137.819 12.4873V148.829C137.798 155.716 132.219 161.296 125.332 161.312Z"
      fill="#DFDFDF"
    />
    <path
      d="M125.332 161.312H60.6904C53.8033 161.295 48.2199 155.712 48.2031 148.825V133.008C89.3787 133.008 101.178 133.008 137.819 133.008V148.829C137.798 155.716 132.219 161.295 125.332 161.312Z"
      fill="#C4C4C4"
    />
    <path
      d="M99.4303 70.1607C98.0834 61.6268 90.6094 55.0769 81.6156 55.0769C78.2322 55.0769 74.981 56.0035 72.1611 57.7318C67.871 50.5949 60.1476 46.1538 51.5675 46.1538C38.3129 46.1538 27.529 56.8284 27.529 69.9487C27.529 70.03 27.529 70.1143 27.5321 70.1956C19.0134 71.6159 12.3047 78.9675 12.3047 87.7948C12.3047 97.6358 20.5921 105.641 30.5339 105.641H96.6396C106.581 105.641 114.869 97.6358 114.869 87.7948C114.869 78.8922 108.052 71.494 99.4303 70.1607Z"
      fill="white"
    />
  </svg>
))
